import isObject from 'lodash/isObject';
import { isRouteErrorResponse } from 'react-router';

const ERROR_RESPONSE__MESSAGES: { [code: number]: string } = {
  400: 'The server encountered an error.',
  401: 'You do not have access to view this page.',
  403: 'You lack permissions to perform this action.',
  404: 'We can’t find the page you’re looking for.',
  500: 'The server encountered an error. Please try again.',
};
const DEFAULT_ERROR = 'Something went wrong.';
export function getErrorResponseMessage(status?: number | null) {
  return status ? ERROR_RESPONSE__MESSAGES[status] || DEFAULT_ERROR : DEFAULT_ERROR;
}

export function getMessageFromErrorResponse(error: unknown) {
  const { status } = getError(error);
  return getErrorResponseMessage(status);
}

export function getError(error: unknown) {
  if (isRouteErrorResponse(error)) {
    if (typeof error.data === 'string') {
      return { message: error.data, status: error.status, statusText: error.statusText };
    } else if ('error' in error.data && 'message' in error.data.error) {
      const status = error.status;
      const statusText = error.statusText;
      return { status, statusText };
    }
  }
  const isResponse = error instanceof Response;
  if (isResponse) {
    const status = error.status;
    const statusText = error.statusText;
    // Always include a message — Response throws from fetchApi have no Error.message,
    // and Sentry.captureException(undefined) becomes title "<unknown>" / "Error: undefined".
    return { message: statusText || `HTTP ${status}`, status, statusText };
  }

  if (error instanceof Error) return { message: error.message };

  return { message: isObject(error) ? JSON.stringify(error) : String(error) };
}

// Basically deprecated but still used in a few places
export function _getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return { message: isObject(error) ? JSON.stringify(error) : String(error) };
}

export function _getErrorResponseMessage(error: unknown) {
  if (isRouteErrorResponse(error)) {
    if ('error' in error.data && 'message' in error.data.error) {
      return error.data.error.message;
    } else if (error.data) {
      return JSON.stringify(error.data);
    }
  }
  return _getErrorMessage(error);
}
